// extracted by mini-css-extract-plugin
export default {"wrapper":"default_wrapper__VL9Co","label":"default_label__7ExPQ","fields":"default_fields__LTfJT","field":"default_field__B7I-B","separator":"default_separator__Sopcl"};